import type { EventCategory, EventType, KnownEventType } from "@safers/api";
const TYPE_LABELS: Record<string, string> = {
  NO_HELMET: "안전모",
  FIRE: "화재",
  GAS_THRESHOLD_EXCEEDED: "가스",
  BAND_VITAL_ABNORMAL: "생체신호",
  HEAT_INDEX_EXCEEDED: "체감온도",
} satisfies Record<KnownEventType, string>;
const CATEGORY_LABELS: Record<string, string> = {
  DETECTION: "영상 감지",
  SAFETY: "안전 센서",
  HEALTH: "보건",
};
export function typeLabel(type: EventType): string {
  return TYPE_LABELS[type] ?? type;
}
export function categoryLabel(category: EventCategory): string {
  return CATEGORY_LABELS[category] ?? category;
}

/**
 * 이벤트 목록의 장치유형 필터 — 이벤트를 낸 장치로 묶는다.
 * 순서가 탭 순서이고, 값은 주소(`?deviceType=`)에 그대로 적힌다.
 */
export const DEVICE_KINDS = ["cctv", "heat", "gas"] as const;
export type DeviceKind = (typeof DEVICE_KINDS)[number];

export const DEVICE_KIND_LABELS: Record<DeviceKind, string> = {
  cctv: "영상감지",
  heat: "체감온도",
  gas: "가스측정",
};

export function deviceKindOf(event: {
  category: EventCategory;
  type: EventType;
}): DeviceKind | null {
  if (event.category === "DETECTION") return "cctv";
  if (event.type === "HEAT_INDEX_EXCEEDED") return "heat";
  if (event.type === "GAS_THRESHOLD_EXCEEDED") return "gas";
  return null;
}

/** 최근 이벤트를 장치유형으로 걸러서 비었을 때의 문구 — "영상감지·체감온도 이벤트가 없습니다". */
export function emptyEventMessage(kinds: DeviceKind[]): string {
  return kinds.length > 0
    ? `${kinds.map((k) => DEVICE_KIND_LABELS[k]).join("·")} 이벤트가 없습니다`
    : "이벤트가 없습니다";
}
